// import library
import { useTranslation } from "react-i18next";
import { useState } from "react";
import RecommendedProductSortComponent from "./RecommendedProduct/Sort";

const RecommendedProductsComponent = ({defaultProductImage, recommendedProductList}) => {
    const { t } = useTranslation();
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return (
        <>
            { recommendedProductList.length > 0 ?
                <div className="p-2 sm:p-0 bg-white sm:bg-transparent border border-white sm:border-none rounded-lg sm:rounded-none space-y-2 sm:space-y-0">
                    <div className="flex sm:hidden justify-between items-center sm:space-x-2 rounded-lg">
                        <h1 className="sm:text-lg font-semibold sm:font-bold capitalize">{ t('all recommended products')}</h1>
                        {/* <div className="flex items-center justify-end space-x-2">
                            <RecommendedProductSortComponent />
                        </div> */}
                    </div>
                    <div className="block sm:hidden my-2 sm:my-4 border-t border-background-normal"></div>
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 sm:gap-4">
                        {recommendedProductList.map((product, index) => (
                            <div key={`product${index}`} className="flex sm:grid bg-white rounded-lg sm:px-4 py-2 sm:space-y-4 space-x-2 sm:space-x-0 sm:shadow-md shadow-around">
                                <div className="flex flex-col justify-center items-center">
                                    <img className="w-28 h-20 sm:w-48 sm:h-48 rounded-lg border border-background-normal sm:border-none" src={product.image ? product.image : defaultProductImage} alt="product-img" />
                                </div>
                                <div className="space-y-2 sm:space-y-4 w-full">
                                    <div className="font-semibold text-xs sm:text-base">
                                        {product.productname}
                                    </div>
                                    <div className="text-light-700 text-[10px] sm:text-sm">
                                        {product.productdescription}
                                    </div>
                                    <div className="flex justify-between items-end">
                                        <div className="flex flex-col justify-between sm:space-y-1">
                                            <div className="text-light-700 text-[10px] sm:text-xs">
                                                <span className="capitalize">{ t("product code")}</span><span className="font-semibold">: {product.item_code}</span>
                                            </div>
                                            <div className="flex justify-between items-center text-light-700">
                                                <div className="capitalize text-[10px] sm:text-xs">{ t('units')}<span className="font-medium">: {product.units}</span></div>
                                                <div className="border-l h-3 border-gray-400"></div>
                                                <div className="capitalize text-light-700 text-[10px] sm:text-xs">{ t('m/m')}<span className="font-medium">: {product.m_m}</span></div>
                                            </div>
                                        </div>
                                        <div className="font-bold text-sm sm:text-lg text-end">{formatter.format(product.price)} €</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            :
                <div className="p-6 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white shadow-around">
                    { t('no records available')}
                </div>
            }
        </>
    )
}

export default RecommendedProductsComponent;